module.exports = __webpack_public_path__ + "static/media/login-bg@2x.c1638f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/login-bg@2x.png
// module id = 349
// module chunks = 0